module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open) ? _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "dialog-tit"
  }, [_c('h4', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "t": "1501234940517",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "3014",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "20",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M941.576 184.248l-101.824-101.824L512 410.176 184.248 82.424 82.424 184.248 410.168 512l-327.744 327.752 101.824 101.824L512 613.824l327.752 327.752 101.824-101.824L613.832 512z",
      "fill": "#cdcdcd",
      "p-id": "3015"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "s-content"
  }, [_vm._t("content")], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-722269c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup.vue
// module id = 650
// module chunks = 0